/* eslint-disable */

import jQuery from 'jquery';
import '../style.scss';

import Router from './util/Router';
import accordion from './custom/accordion';
import expand from '../components/objects/card-event/card-event';
import filterByTaxonomy from '../js/custom/filterBy/filterByTaxonomy';
import scrollToTop from '../components/objects/scroll-to-top/scroll-to-top';
import searchBar from '../components/objects/search/search-bar/search-bar';
import navMob from '../components/objects/nav/nav-mobile/nav-mobile';
import slider from '../components/blocks-zone-yellow/slider/slider';
import { showSearchBox } from '../layouts/header/header';
import socialShare from '../components/objects/social/social-share/social-share';
import gallery from '../components/blocks-zone-yellow/gallery/gallery';
import {
    hamburger,
    hamburgerClose
} from '../components/objects/nav/hamburger/hamburger';

import comments from '../components/objects/content/comments/comments';


import scrollToAnchor from './custom/scroll/scroll-to-anchor';
import parallaxScroll from './custom/parallax/parallaxscroll';
import headRoom from './custom/headroom/headroom';

import './core/core';

/** Responsive Images Polyfill */
import 'picturefill';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({

});

// functions below are only run if the component exists (verified through a "data-module" in the html)
// in the ajax container or page. Barba.js instantiates the functions below on container reload as well.

// Place in alphabetical order
const app = {
    accordion,
    expand,
    filterByTaxonomy,
    hamburger,
    scrollToTop,
    searchBar,
    showSearchBox,
    gallery,
    headRoom,
    slider,
    socialShare,
    comments
};
app.instantiate = function(elem) {
    const $this = $(elem);
    const module = $this.attr('data-module');

    if (module === undefined) {
        throw 'Module not defined (use data-module="")';
    } else if (module in app) {
        if ($this.attr('data-initialized') === 'true') return;
        new app[module](elem);
        $this.attr('data-initialized', true);
    } else {
        throw "Module '" + module + "' not found";
    }
};

jQuery(document).ready(function() {
    routes.loadEvents();

    scrollToAnchor($);
    navMob($);

    // open links inside content in a new tab
    $(".c-content a").attr("target","_blank");

    // Component functions that should only run if the component exists in the ajax container or page
    $('[data-module]').each(function() {
        app.instantiate(this);
    });
});

jQuery(window).scroll(function() {
    parallaxScroll(jQuery);
});
